/**
 * Вызов модалок
 */

;
window.MoK = (() => {
        "use strict";

        const ModalsStates = {
                confirmEmail: {
                        newEmail: "",
                        isConfirmed: false,
                        verifiedCode: "",
                }
        };

        const ModalsKit = {
                /**
                 * Создает динамическую модалку из HTML-строки или DOM-элемента.
                 *
                 * @param {string|HTMLElement|Node} htmlContent - HTML-строка или DOM-элемент с контентом.
                 * @param {Object} options - Настройки.
                 * @param {string} options.className - Дополнительные классы для обертки.
                 * @param {Array<string>} options.closeSelectors - Селекторы элементов для закрытия.
                 * @param {Function} options.onClose - Функция при закрытии.
                 * @param {boolean} options.closeOnBackdrop - Закрывать при клике на фон.
                 * @param {boolean} options.closeOnEsc - Закрывать по ESC.
                 * @returns {Object} Объект с методом close() и DOM-элементами { close, wrapper, box }.
                 */
                createDynamicModal(htmlContent, options = {}) {
                        const config = {
                                className: '',
                                closeSelectors: ['.modal-pure__close'],
                                confirmSelectors: [], // селекторы подтверждения модалки. При выборе закрывают модалку. Также они вызывают хук onTrueClick
                                onClose: null,
                                onTrueClick: null,
                                closeOnBackdrop: true,
                                closeOnEsc: true,
                                ...options
                        };
                        let wrapper, box;
                        // 1. Определяем тип htmlContent
                        let contentElement;
                        if (typeof htmlContent === 'string') {
                                const temp = document.createElement('div');
                                temp.innerHTML = htmlContent.trim();
                                contentElement = temp.firstElementChild || document.createTextNode(htmlContent);
                        } else if (htmlContent instanceof HTMLElement || htmlContent instanceof Node) {
                                contentElement = htmlContent;
                        } else {
                                console.error('createDynamicModal: htmlContent должен быть строкой или DOM-элементом');
                                return null;
                        }

                        // 2 используем готовую обёртку
                        wrapper = document.createElement('div');
                        wrapper.className = `aDialog-custom modal-pure dynamic-modal ${config.className}`.trim();
                        box = document.createElement('div');
                        box.className = 'modal-pure__box';
                        box.appendChild(contentElement);
                        wrapper.appendChild(box);

                        // 3. Добавляем кнопку закрытия (крестик), если её нет
                        const existingCloseBtn = HK.saveQuery(wrapper, '.modal-pure__close');
                        if (!HK.isRealElement(existingCloseBtn)) {
                                const closeBtn = document.createElement('div');
                                closeBtn.className = 'modal-pure__close';
                                box.appendChild(closeBtn);
                        }

                        // 4. Добавляем в DOM и блокируем скролл
                        document.body.appendChild(wrapper);
                        document.body.classList.add('overflow', 'modal-opened');
                        // 5. Показываем
                        wrapper.style.display = 'flex';
                        requestAnimationFrame(() => {
                                wrapper.classList.add('active');
                        });
                        let isClosed = false;
                        // 6. Функция закрытия
                        function closeDialog(isConfirm = false, target = null) {
                                if (isClosed) {
                                        return;
                                }
                                isClosed = true;
                                wrapper.classList.remove('active');

                                document.removeEventListener('keydown', handleEsc);
                                wrapper.removeEventListener('click', handleBackdropClick);
                                // Снимаем обработчики с кнопок
                                const allSelectors = [...config.closeSelectors, ...config.confirmSelectors];
                                const buttons = HK.saveQueryAll(wrapper, allSelectors);
                                buttons.forEach(btn => {
                                        btn.removeEventListener('click', handleCloseClick);
                                        btn.removeEventListener('click', handleConfirmClick);
                                });
                                const duration = parseFloat(getComputedStyle(wrapper).transitionDuration) * 1000 || 300;
                                setTimeout(() => {
                                        if (wrapper.parentNode) {
                                                wrapper.parentNode.removeChild(wrapper);
                                        }

                                        // Вызываем колбэки
                                        if (isConfirm && typeof config.onTrueClick === 'function') {
                                                config.onTrueClick(target);
                                        }

                                        document.body.classList.remove('overflow', 'modal-opened');

                                        if (typeof config.onClose === 'function') {
                                                config.onClose(isConfirm);
                                        }
                                }, duration);
                        }

                        // 7. Обработчики кликов по кнопкам
                        function handleCloseClick(e) {
                                e.stopPropagation();
                                closeDialog(false);
                        }

                        function handleConfirmClick(e) {
                                e.stopPropagation();
                                closeDialog(true, e.currentTarget);
                        }

                        // Навешиваем обработчики
                        const closeButtons = HK.saveQueryAll(wrapper, config.closeSelectors);
                        closeButtons.forEach(btn => btn.addEventListener('click', handleCloseClick));
                        const confirmButtons = HK.saveQueryAll(wrapper, config.confirmSelectors);
                        confirmButtons.forEach(btn => btn.addEventListener('click', handleConfirmClick));
                        // 8. Клик по фону
                        function handleBackdropClick(e) {
                                if (config.closeOnBackdrop && e.target === wrapper) {
                                        closeDialog(false);
                                }
                        }
                        wrapper.addEventListener('click', handleBackdropClick);
                        // 9. ESC
                        function handleEsc(e) {
                                if (config.closeOnEsc && e.keyCode === 27) {
                                        closeDialog(false);
                                }
                        }
                        if (config.closeOnEsc) {
                                document.addEventListener('keydown', handleEsc);
                        }

                        return {
                                close: closeDialog,
                                wrapper: wrapper,
                                box: box
                        };
                },

                /**
                 * Показ модального окна с требованиями к загружаемым файлам.
                 * При нажатии "Ознакомлен" сохраняет флаг в localStorage и открывает стандартный file input.
                 *
                 * @param {jQuery} parent_btn - jQuery-объект родителя (контейнер .fileform), внутри которого находится input[type=file].
                 */
                showFileAccept(parent_btn) {
                        // Создаем динамически модалку
                        this.createDynamicModal(TK.modal.filesAccept(), {
                                className: 'dynamic-modal-list',
                                closeSelectors: ['.modal-pure__close'], // крестик — просто закрывает
                                confirmSelectors: ['.blue-button'], // "Ознакомлен" — выполняет логику
                                onTrueClick: function () {
                                        // Эта логика выполнится ТОЛЬКО при клике на "Ознакомлен"
                                        localStorage.setItem('loadFileAcceptHide', true);
                                        $("input[type=file]", parent_btn).val('').click();
                                },
                                onClose: function (isConfirm) {
                                        // Эта логика выполнится при ЛЮБОМ закрытии (опционально)
                                }
                        });
                },

                /**
                 * Показ модального окна с требованиями к загружаемым изображениям лотов.
                 */
                showLotPhotoRequirements() {
                        this.createDynamicModal(TK.modal.lotPhotoRequirements(), {
                                className: 'dynamic-modal-list',
                                closeSelectors: ['.modal-pure__close'], // закрытие только по крестику
                                onClose: function () {
                                        // console.log('Модалка с требованиями к фото закрыта');
                                }
                        });
                },
                showDepositTypes(lotId = null, summa = null) {
                        this.createDynamicModal(TK.modal.depositTypes(lotId, summa), {
                                closeSelectors: ['.modal-pure__close'],
                                confirmSelectors: ['.blue-button'],

                                onTrueClick: (button) => {
                                        const type = button.dataset.paymentType;

                                        if (type === 'express') {

                                        }

                                        if (type === 'requisites') {
                                                qrDialog(lotId);
                                        }
                                }
                        })
                },

                // showChangeEmail(params = {}) {

                //         const {
                //                 title = "",
                //                 inn = "",
                //                 email = ""
                //         } = params;

                //         if (!title || !inn || !email) {
                //                 aAlert("Недостаточно данных для формирования заявления");
                //                 return;
                //         }

                //         const state = ModalsStates.confirmEmail;

                //         const modal = this.createDynamicModal(
                //                 TK.modal.changeEmail(
                //                         title,
                //                         inn,
                //                         email,
                //                         state.newEmail
                //                 ),
                //                 {
                //                         closeSelectors: ['.modal-pure__close']
                //                 }
                //         );

                //         if (!modal) {
                //                 return;
                //         }

                //         const wrapper = modal.wrapper;
                //         const input = wrapper.querySelector(
                //                 '.change-email-modal__input'
                //         );
                //         const clearBtn = wrapper.querySelector(
                //                 '.change-email-modal__clear'
                //         );
                //         const btnConfirm = wrapper.querySelector(
                //                 '.change-email-modal__btn-confirm'
                //         );
                //         const btnSend = wrapper.querySelector(
                //                 '.change-email-modal__btn-send'
                //         );

                //         if (!input || !clearBtn || !btnConfirm || !btnSend) {
                //                 modal.close();
                //                 return;
                //         }

                //         let verifiedCode = state.verifiedCode || "";

                //         const maskMethod = (
                //                 typeof maskEmail !== 'undefined'
                //         )
                //                 ? maskEmail
                //                 : (value) => value;

                //         /*
                //          * Восстанавливаем состояние модалки.
                //          */
                //         input.value = state.newEmail;

                //         if (state.isConfirmed && verifiedCode) {
                //                 btnConfirm.style.display = 'none';
                //                 btnSend.style.display = 'inline-block';
                //                 clearBtn.style.display = 'inline-block';
                //                 input.disabled = true;
                //         } else {
                //                 btnConfirm.style.display = 'inline-block';
                //                 btnSend.style.display = 'none';
                //                 clearBtn.style.display = state.newEmail
                //                         ? 'inline-block'
                //                         : 'none';
                //                 input.disabled = false;
                //         }

                //         /*
                //          * Сбрасывает подтверждение, но сохраняет введенную почту.
                //          */
                //         const resetConfirmation = () => {

                //                 state.isConfirmed = false;
                //                 state.verifiedCode = "";

                //                 verifiedCode = "";

                //                 btnConfirm.style.display = 'inline-block';
                //                 btnSend.style.display = 'none';
                //                 clearBtn.style.display = input.value
                //                         ? 'inline-block'
                //                         : 'none';
                //                 input.disabled = false;
                //         };

                //         /*
                //          * Изменение почты автоматически сбрасывает подтверждение.
                //          */
                //         input.addEventListener('input', () => {

                //                 state.newEmail = input.value.trim();

                //                 state.isConfirmed = false;
                //                 state.verifiedCode = "";

                //                 verifiedCode = "";

                //                 btnConfirm.style.display = 'inline-block';
                //                 btnSend.style.display = 'none';
                //                 clearBtn.style.display = input.value
                //                         ? 'inline-block'
                //                         : 'none';

                //                 input.disabled = false;
                //         });

                //         /*
                //          * Очистка введенной почты.
                //          */
                //         clearBtn.addEventListener('click', () => {

                //                 input.value = "";

                //                 state.newEmail = "";
                //                 state.isConfirmed = false;
                //                 state.verifiedCode = "";

                //                 verifiedCode = "";

                //                 btnConfirm.style.display = 'inline-block';
                //                 btnSend.style.display = 'none';
                //                 clearBtn.style.display = 'none';

                //                 input.disabled = false;
                //                 input.focus();
                //         });

                //         /*
                //          * Подтверждение новой почты.
                //          */
                //         btnConfirm.addEventListener('click', () => {

                //                 const currentEmail = input.value.trim();

                //                 const validation = FFK.validate(
                //                         'email',
                //                         currentEmail
                //                 );

                //                 if (!validation.isValid) {
                //                         aAlert(
                //                                 validation.error.message
                //                                 || "Некорректный E-mail"
                //                         );
                //                         return;
                //                 }

                //                 MoK.showVerifCode({
                //                         type: 'new_email',
                //                         contactValue: currentEmail,
                //                         maskMethod: maskMethod,
                //                         length: PARAMS?.email_confirm_code ?? 6,
                //                         interval: 60,
                //                         title: 'Изменение почты',
                //                         descriptionText:
                //                                 'Введите код, отправленный на электронную почту ',

                //                         onSuccess: (result) => {

                //                                 state.newEmail = currentEmail;
                //                                 state.isConfirmed = true;
                //                                 state.verifiedCode = result.code;

                //                                 verifiedCode = result.code;

                //                                 btnConfirm.style.display = 'none';
                //                                 btnSend.style.display = 'inline-block';
                //                                 clearBtn.style.display = 'inline-block';

                //                                 input.disabled = true;
                //                         }
                //                 });
                //         });

                //         /*
                //          * Отправка заявления.
                //          */
                //         btnSend.addEventListener('click', async () => {

                //                 if (!verifiedCode) {
                //                         aAlert(
                //                                 "Код подтверждения не найден. "
                //                                 + "Пожалуйста, подтвердите почту заново."
                //                         );

                //                         resetConfirmation();
                //                         return;
                //                 }

                //                 const currentEmail = input.value.trim();

                //                 const validation = FFK.validate(
                //                         'email',
                //                         currentEmail
                //                 );

                //                 if (!validation.isValid) {
                //                         aAlert(
                //                                 validation.error.message
                //                                 || "Некорректный E-mail"
                //                         );
                //                         return;
                //                 }

                //                 const payload = {
                //                         new_email: currentEmail,
                //                         code: verifiedCode,
                //                         phone: "",
                //                         sign: ""
                //                 };

                //                 btnSend.disabled = true;

                //                 const originalBtnText = btnSend.textContent;
                //                 btnSend.textContent = "Отправка...";

                //                 const result = await UK.changeEmail(payload);

                //                 btnSend.disabled = false;
                //                 btnSend.textContent = originalBtnText;

                //                 if (result && result.success) {

                //                         aAlert(
                //                                 result.message
                //                                 || "Заявление успешно отправлено"
                //                         );

                //                         state.newEmail = "";
                //                         state.isConfirmed = false;
                //                         state.verifiedCode = "";

                //                         verifiedCode = "";

                //                         modal.close();

                //                 } else {

                //                         aAlert(
                //                                 result?.error
                //                                 || "Ошибка при отправке заявления"
                //                         );

                //                         resetConfirmation();
                //                 }
                //         });
                // },

                /**
                 * Показывает модальное окно для ввода кода подтверждения.
                 *
                 * @param {Object} config - Конфигурация модалки
                 * @param {string} config.type - Тип контакта: 'phone', 'email' или 'new_email'
                 * @param {string} config.contactValue - Значение контакта (телефон или почта)
                 * @param {Function} config.maskMethod - Функция маскировки (например, maskPhone или maskEmail)
                 * @param {number} [config.length=4] - Количество инпутов для кода
                 * @param {number} [config.interval=60] - Интервал таймера в секундах
                 * @param {string} config.title - Заголовок модалки
                 * @param {string} config.descriptionText - Текст описания (перед замаскированным контактом)
                 * @param {Function} config.onSuccess - Колбэк, вызываемый при успешной проверке кода. Принимает { code, contactValue }
                 */
                async showVerifCode({
                        type,
                        contactValue,
                        maskMethod,
                        length = 4,
                        interval = 60,
                        title,
                        descriptionText,
                        onSuccess
                }) {
                        const STORAGE_END_TIME = `verif_${type}_endTime`;
                        const STORAGE_CONTACT = `verif_${type}_contact`;
                        const maskedValue = maskMethod(contactValue);

                        // Генерируем HTML через TemplatesKit
                        const html = TK.modal.verifCode(title, descriptionText, maskedValue, length);

                        let timerTimeout = null;

                        // Создаем модалку через createDynamicModal
                        const modal = this.createDynamicModal(html, {
                                className: 'verifCodeDialog',
                                closeSelectors: ['.modal-pure__close'],
                                closeOnBackdrop: false, // Запрещаем закрытие по клику на фон для важных действий
                                onClose: () => {
                                        if (timerTimeout) {
                                                clearTimeout(timerTimeout);
                                        }
                                }
                        });

                        if (!modal) {
                                return;
                        }

                        const wrapper = modal.wrapper;
                        const timerBtn = wrapper.querySelector('.verif-code__timer');
                        const inputsContainer = wrapper.querySelector('.verif-code__inputs');

                        // Логика таймера
                        const updateTimerDisplay = () => {
                                const endTime = localStorage.getItem(STORAGE_END_TIME);
                                if (!endTime || isNaN(endTime)) {
                                        return false;
                                }

                                const deltaTime = Math.floor((endTime - new Date().getTime()) / 1000);
                                if (deltaTime > 0) {
                                        timerBtn.style.pointerEvents = 'none';
                                        //timerBtn.style.opacity = '0.6';
                                        const timeStr = (typeof secToTime === 'function') ? secToTime(deltaTime, true) : `${deltaTime} сек.`;
                                        timerBtn.textContent = `Повторная отправка кода будет доступна через ${timeStr}`;
                                        return true;
                                } else {
                                        localStorage.removeItem(STORAGE_END_TIME);
                                        localStorage.removeItem(STORAGE_CONTACT);
                                        timerBtn.style.pointerEvents = 'auto';
                                        //timerBtn.style.opacity = '1';
                                        timerBtn.textContent = "Запросить код ещё раз";
                                        return false;
                                }
                        };

                        const timerDecrement = () => {
                                if (updateTimerDisplay()) {
                                        timerTimeout = setTimeout(timerDecrement, 1000);
                                } else {
                                        if (timerTimeout) clearTimeout(timerTimeout);
                                }
                        };

                        // API: Отправка кода
                        const sendCode = async () => {
                                if (updateTimerDisplay()) return; // Таймер еще активен

                                timerBtn.style.pointerEvents = 'none';
                                timerBtn.textContent = "Отправка...";

                                const result = await UK.api.sendVerificationCode(type, contactValue);
                                if (!result.success) {
                                        modal.close();
                                        if (typeof aAlert === 'function') {
                                                aAlert(result.error || "Ошибка отправки кода");
                                        }
                                        return;
                                }

                                const endTime = Date.now() + (interval * 1000);
                                localStorage.setItem(STORAGE_END_TIME, endTime);
                                localStorage.setItem(STORAGE_CONTACT, maskedValue);

                                // Очистка полей ввода
                                const inputs = inputsContainer.querySelectorAll('.verif-code__input');
                                inputs.forEach(input => input.value = '');
                                inputs[0]?.focus();

                                timerDecrement();
                        };

                        // API: Проверка кода
                        const checkCode = async (code) => {
                                timerBtn.style.pointerEvents = 'none';
                                const result = await UK.api.checkVerificationCode(type, contactValue, code);

                                if (result.success) {
                                        modal.close();
                                        if (typeof onSuccess === 'function') {
                                                onSuccess({ code, contactValue });
                                        }
                                } else {
                                        aAlert("Вы ввели неверный код. Попробуйте еще раз");
                                        const inputs = inputsContainer.querySelectorAll('.verif-code__input');
                                        inputs.forEach(input => input.value = '');
                                        inputs[0]?.focus();
                                }
                        };

                        // Обработчик повторной отправки
                        timerBtn.addEventListener('click', (e) => {
                                e.preventDefault();
                                sendCode();
                        });

                        // Инициализация ввода кода
                        const setupInputs = setupConfirmCodeInputs({
                                container: inputsContainer,
                                callback: checkCode
                        });

                        // Запуск процесса
                        if (updateTimerDisplay()) {
                                timerDecrement();
                        } else {
                                await sendCode();
                        }

                        setupInputs.focus();
                },
        }

        const confirmsKit = {
                async aConfirmYesNoCancel(text, yesTitle = "Да", noTitle = "Нет", cancelTitle = "Отмена") {
                        // Создаем диалог
                        var $dialog = aCreateDialog();
                        $dialog.addClass("aConfirm");

                        $(".modal-pure__infopart", $dialog).html(text);
                        $(".modal-pure__buttons", $dialog).html('');

                        // Создаем три кнопки.
                        var $yes = $("<button class='blue-button ok'>" + yesTitle + "</button>");
                        var $no = $("<button class='light-blue-button no'>" + noTitle + "</button>");
                        var $cancel = $("<button class='grey-button cancel'>" + cancelTitle + "</button>");

                        // Порядок кнопок в модалке
                        $(".modal-pure__buttons", $dialog).append($yes).append($no).append($cancel);

                        $dialog.showDialog();
                        setTimeout(() => $yes.focus(), 1);

                        // Создаем свой Promise с тремя состояниями: true, false, "no"
                        return new Promise(function (resolve) {

                                // 1. Обработчик для "Да"
                                $yes.on("click", function (event) {
                                        event.preventDefault();
                                        event.stopPropagation();
                                        $dialog.closeDialog();
                                        resolve(true);
                                });

                                // 2. Обработчик для "Нет"
                                $no.on("click", function (event) {
                                        event.preventDefault();
                                        event.stopPropagation();
                                        $dialog.closeDialog();
                                        resolve("no"); // Возвращаем строку, чтобы жестко отличать от false (Отмены)
                                });

                                // 3. Обработчик для "Отмена"
                                $cancel.on("click", function (event) {
                                        event.preventDefault();
                                        event.stopPropagation();
                                        $dialog.closeDialog();
                                        resolve(false);
                                });

                                // 4. Закрытие по клику на затемненный фон или крестик (считаем как "Отмена")
                                $dialog.on("click", function (e) {
                                        if (e.target === this || e.target === $dialog.find(".modal-pure__close")[0]) {
                                                $dialog.closeDialog();
                                                resolve(false);
                                        }
                                });

                                // 5. Закрытие по клавише Escape (считаем как "Отмена")
                                $dialog.on("escape", function (event) {
                                        event.preventDefault();
                                        event.stopPropagation();
                                        $dialog.closeDialog();
                                        resolve(false);
                                });
                        });
                }
        }

        let catalogInstance = null;

        // не модалки но вызываются
        const windowsKit = {
                /**
                 * Открытие каталога имущества.
                 *
                 * Работает как выпадающая панель под навигацией:
                 * - без затемнения;
                 * - без блокировки scroll;
                 * - повторный клик закрывает каталог;
                 * - закрытие по клику вне каталога;
                 * - закрытие по Escape.
                 */
                async showCatalog() {

                        // Если каталог уже открыт — закрываем
                        if (catalogInstance) {
                                catalogInstance.close();
                                return;
                        }

                        const navContainer = HK.saveQuery(
                                document,
                                '.page__nav_container'
                        );

                        if (!HK.isRealElement(navContainer)) {
                                console.error(
                                        '[Catalog] Не найден .page__nav_container'
                                );

                                return;
                        }

                        let catalogData;

                        try {
                                catalogData = await DK.get('catalog_category');
                        } catch (e) {
                                console.error(
                                        '[Catalog] Ошибка загрузки категорий:',
                                        e
                                );

                                return;
                        }

                        if (catalogInstance) {
                                return;
                        }

                        const wrapper = document.createElement('div');

                        wrapper.className = 'catalog-dropdown';

                        wrapper.innerHTML = TK.catalog(catalogData);

                        // Добавляем прямо в навигацию
                        navContainer.appendChild(wrapper);


                        // Показываем
                        requestAnimationFrame(() => {
                                wrapper.classList.add('active');

                                const link = document.getElementById("catalog-btn");
                                link && link.classList.add('active');

                                if (isMobile) {
                                        const menuWrapper = document.getElementById("page__nav_container_content__container");
                                        menuWrapper && menuWrapper.classList.add('hidden');
                                }
                        });


                        let isClosed = false;


                        function close() {

                                if (isClosed) {
                                        return;
                                }

                                isClosed = true;

                                const link = document.getElementById("catalog-btn");
                                link && link.classList.remove('active');

                                wrapper.classList.remove('active');

                                if (isMobile) {
                                        const menuWrapper = document.getElementById("page__nav_container_content__container");
                                        menuWrapper && menuWrapper.classList.remove('hidden');
                                }

                                document.removeEventListener(
                                        'click',
                                        handleOutsideClick
                                );

                                document.removeEventListener(
                                        'keydown',
                                        handleEsc
                                );

                                const duration =
                                        parseFloat(
                                                getComputedStyle(wrapper).transitionDuration
                                        ) * 1000 || 200;

                                setTimeout(() => {

                                        if (wrapper.parentNode) {
                                                wrapper.parentNode.removeChild(wrapper);
                                        }

                                }, duration);

                                catalogInstance = null;
                        }


                        function handleOutsideClick(e) {

                                if (wrapper.contains(e.target)) {
                                        return;
                                }

                                const catalogButton = e.target.closest(
                                        '.navigation_btn .link[title="Каталог"]'
                                );

                                if (catalogButton) {
                                        return;
                                }

                                close();
                        }


                        function handleEsc(e) {

                                if (e.key === 'Escape' || e.keyCode === 27) {
                                        close();
                                }
                        }


                        /**
                         * Переход по конечной категории.
                         */
                        function handleCatalogClick(e) {

                                const item = e.target.closest('[data-value]');

                                if (!item || !wrapper.contains(item)) {
                                        return;
                                }

                                e.preventDefault();

                                const value = item.dataset.value;

                                const url = HK.getSearchLink({
                                        search_category: value
                                });

                                window.location.href = url;
                        }


                        wrapper.addEventListener(
                                'click',
                                handleCatalogClick
                        );


                        /*
                         * Добавляем с небольшой задержкой,
                         * чтобы клик, открывший каталог,
                         * не сразу закрыл его.
                         */
                        setTimeout(() => {

                                document.addEventListener(
                                        'click',
                                        handleOutsideClick
                                );

                                document.addEventListener(
                                        'keydown',
                                        handleEsc
                                );

                        }, 0);


                        catalogInstance = {
                                close,
                                wrapper
                        };

                        return catalogInstance;
                },
        }


        // то, что будет доступно снаружи
        const publicAPI = {
                ...ModalsKit,
                ...windowsKit,
                ...confirmsKit,
        };

        return publicAPI;
})();
